export const i18nSensorsPage = {
  sections: {
    total: 'Total',
    data_health: 'Status (data health)',
    sensors_data: 'Dados dos sensores',
  },
  components: {
    status_table: {
      headers: {
        status: 'Status',
        description: 'Descrição',
        label: 'Tag/Código',
        value: 'Última leitura',
        low_low_threshold: 'Lo Lo',
        low_threshold: 'Lo',
        high_threshold: 'Hi',
        high_high_threshold: 'Hi Hi',
        display_threshold: 'Mostrar limites',
      },
      no_value: 'Sem valor',
      edit: 'Editar {{tag}}',
    },
    edit_modal: {
      low_low_threshold: 'Lo Lo',
      low_threshold: 'Lo',
      high_threshold: 'Hi',
      high_high_threshold: 'Hi Hi',
      submit_btn: 'Salvar',
      clear_btn: 'Limpar',
      details_reason: 'Motivo / Justificativa',
    },
    tabs: {
      edit: 'Editar limites',
      history: 'Histórico',
    },
    history: {
      headers: {
        date: 'Data / hora',
        low_low_threshold: 'Lo Lo',
        low_threshold: 'Lo',
        high_threshold: 'Hi',
        high_high_threshold: 'Hi Hi',
        reason: 'Detalhes / motivo',
        user: 'Usuário',
      },
    },
  },
  message: {
    limit_error: {
      title: 'Ops...',
      message: 'Erro as atualizar limites. Por favor, tente novamente.',
    },
    limit_success: {
      title: 'Sucesso',
      message: 'Limites atualizados com sucesso!',
    },
    asset_error: {
      title: 'Ops..',
      message:
        'Não foi possível carregar dados do equipamento. Aguarde alguns minutos e tente novamente',
    },
    sensors_status_error: {
      title: 'Ops..',
      message:
        'Não foi possível carregar dados dos sensores. Aguarde alguns minutos e tente novamente',
    },
    no_alarms: {
      title: 'Sem alarmes',
    },
    alarms_error: {
      title: 'Ops..',
      message:
        'Não foi possível carregar dados do alarme. Aguarde alguns minutos e tente novamente',
    },
  },
};
